module.exports = __webpack_public_path__ + "static/wedding-4_PLACEHOLDER-6e3b58f1efaec76d20b5adf55ccea913.jpg";